module.exports = __webpack_public_path__ + "static/sebrae-0193bf18c22381a3b9234337fcf8aa42.png";